import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import { RestaurantCartProvider } from '@happyspace/sdk/restaurant';
import { Nav, Footer } from './components/Chrome';
import { CartUIProvider } from './lib/cartUi';
import { CartDrawer } from './components/CartDrawer';
import Home from './pages/Home';
import MenuPage from './pages/MenuPage';
import About from './pages/About';
import Visit from './pages/Visit';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import BlogPost from './pages/blog/best-parotta-restaurants-coppell';
import BlogPostOmaha from './pages/blog/best-indian-restaurant-omaha-council-bluffs';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div className="wrap min-h-[70vh] grid place-items-center text-center pt-32">
      <div>
        <p className="eyebrow">404</p>
        <h1 className="font-display mt-3 text-ink" style={{ fontSize: 'clamp(2.2rem, 6vw, 3.6rem)' }}>
          This page went off the menu.
        </h1>
        <p className="mt-4 text-ink-2">Let’s get you back to the good stuff.</p>
        <div className="mt-7 flex justify-center gap-3">
          <Link to="/" className="btn btn-primary">Home</Link>
          <Link to="/menu" className="btn btn-ghost">See the menu</Link>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const Cart = RestaurantCartProvider || (({ children }: any) => children);
  return (
    <Cart>
      <BrowserRouter>
        <CartUIProvider>
          <ScrollToTop />
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/visit" element={<Visit />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-confirmation" element={<OrderConfirmation />} />
              <Route path="/blog/best-parotta-restaurants-coppell" element={<BlogPost />} />
              <Route path="/blog/best-indian-restaurant-omaha-council-bluffs" element={<BlogPostOmaha />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <CartDrawer />
        </CartUIProvider>
      </BrowserRouter>
    </Cart>
  );
}


/* injected: entrance-visibility failsafe — content must never stay invisible */
if (typeof window !== 'undefined') {
  var __hsReveal = function(){
    try {
      document.querySelectorAll('.reveal,.fade-in,.fade-up,[data-reveal],[data-aos]').forEach(function(el){ el.classList.add('in','visible','revealed','active','aos-animate'); });
      document.querySelectorAll('*').forEach(function(node){
        var el = node as HTMLElement;
        var cs = getComputedStyle(el);
        if (parseFloat(cs.opacity) < 0.05 && el.getClientRects().length) {
          // Skip elements that are part of the cart drawer or have pointer-events-none (like overlays/scrims) to prevent dimming the whole site
          if (el.closest('#cart-drawer-root') || el.classList.contains('pointer-events-none') || cs.pointerEvents === 'none') {
            return;
          }
          el.style.setProperty('opacity','1','important');
          if (cs.transform && cs.transform !== 'none') el.style.setProperty('transform','none','important');
        }
      });
    } catch(e){}
  };
  window.addEventListener('load', function(){ setTimeout(__hsReveal, 1500); setTimeout(__hsReveal, 3500); });
}
